import Loadable from 'react-loadable';

const modelNotExisted = (app, model) => (
  // eslint-disable-next-line
  !app._models.some(({ namespace }) => {
    return namespace === model.substring(model.lastIndexOf('/') + 1);
  })
);

function dynamicWrapper(app, models, component) {
  return Loadable({
    loader: component,
    loading: () => null,
    model: models.forEach((model) => {
      if (model && modelNotExisted(app, model)) {
        // eslint-disable-next-line
        app.model(require(`../models/${model}`).default);
      }
    })
  });
}

export const getRouterData = (app) => {
  const routerConfig = [
    {
      path: '/',
      component: dynamicWrapper(app, [], () => import('../views/Home/')),
      exact: true,
      header: true
    },
    {
      path: '/h5/landing-page',
      component: dynamicWrapper(app, [], () => import('../views/H5/')),
      exact: true,
    },
    {
      path: '/vendor/announcement',
      component: dynamicWrapper(app, [], () => import('../views/Announcement/')),
      exact: true,
      header: true
    },
    {
      path: '/principle',
      component: dynamicWrapper(app, [], () => import('../views/Principle/')),
      header: true
    },
    {
      path: '/process',
      component: dynamicWrapper(app, [], () => import('../views/Process/')),
      header: true
    },
    {
      path: '/register/basic/step-one',
      component: dynamicWrapper(app, [], () => import('../views/Register/StepOne/')),
      header: true
    },
    {
      path: '/register/basic/step-two',
      component: dynamicWrapper(app, [], () => import('../views/Register/StepTwo/')),
      header: true
    },
    {
      path: '/register/basic/step-three',
      component: dynamicWrapper(app, [], () => import('../views/Register/StepThree/')),
      header: true
    },
    {
      path: '/register/basic/step-four',
      component: dynamicWrapper(app, [], () => import('../views/Register/StepFour/')),
      header: true
    },
    {
      path: '/register/basic/step-five',
      component: dynamicWrapper(app, [], () => import('../views/Register/StepFive/')),
      header: true
    },
    {
      path: '/register/basic/step-six',
      component: dynamicWrapper(app, [], () => import('../views/Register/StepSix/')),
      header: true
    },
    {
      path: '/register/finished',
      component: dynamicWrapper(app, [], () => import('../views/Register/StepFinished')),
      header: true
    },
    {
      path: '/register/basic-ablity',
      component: dynamicWrapper(app, [], () => import('../views/Register/Category/BasicAbility/')),
      header: true
    },
    {
      path: '/register/hard-ware',
      component: dynamicWrapper(app, [], () => import('../views/Register/Category/Hardware/')),
      header: true
    },
    {
      path: '/register/hard-ware-dieCasting',
      component: dynamicWrapper(app, [], () => import('../views/Register/Category/HardwareWithDieCasting/')),
      header: true
    },
    {
      path: '/register/hard-ware-process',
      component: dynamicWrapper(app, [], () => import('../views/Register/Category/HardwareWithProcess/')),
      header: true
    },
    {
      path: '/register/plastic',
      component: dynamicWrapper(app, [], () => import('../views/Register/Category/Plastic')),
      header: true
    },
    {
      path: '/register/surface',
      component: dynamicWrapper(app, [], () => import('../views/Register/Category/Surface')),
      header: true
    },
    {
      path: '/register/section',
      component: dynamicWrapper(app, [], () => import('../views/Register/Category/Section/')),
      header: true
    },
    {
      path: '/vendor-import/index',
      component: dynamicWrapper(app, [], () => import('../views/VendorImport/index.js')),
      header: true
    },
    {
      path: '/vendor-import/result',
      component: dynamicWrapper(app, [], () => import('../views/VendorImport/result.js')),
      header: true
    },
    {
      path: '/500',
      component: dynamicWrapper(app, [], () => import('../views/ServerError/')),
      header: true
    },
  ];
  return routerConfig;
};
